export const testAttributes = {
    WP_PAGE_ROOT: 'wp-page-root',
    WP_PAGE_LAYOUT: 'wp-page-layout',
    WP_PAGE_RELATED_GRID: 'wp-page-related-grid'
}
